import { ModelInstance, BaseModel, ToFrontHook, ToBackHook, DateTimeField } from './util';
import { GameStatisticBase } from './game-statistic-base';

@ModelInstance({
  mappingFields: {
    game_user_id: 'gameUserId',
    updated_at: 'updatedAt',
    points: 'points',
    tries: 'tries',
    penalty_tries: 'penaltyTries',
    conversion_goals: 'conversionGoals',
    conversion_misses: 'conversionMisses',
    penalty_misses: 'penaltyMisses',
    penalty_goals: 'penaltyGoals',
    drop_goals: 'dropGoals',
    drop_goal_misses: 'dropGoalMisses',
    free_kicks: 'freeKicks',
    yellow_cards: 'yellowCards',
    red_cards: 'redCards',
    red_cards_20: 'redCards20',
    offloads: 'offloads',
    tackles: 'tackles',
    handling_errors: 'handlingErrors',
    carries_over_gainline: 'carriesOverGainline',
    foot_field_shots: 'footFieldShots',
    foot_out_shots: 'footOutShots',
    foot_kicks_50_22: 'footKicks5022',
    fouls: 'fouls',
    team_fouls: 'teamFouls',
    outs: 'outs',
    runs: 'runs',
    game_time: 'gameTime',
    plus_minus: 'plusMinus'
  },
  relation: {
    updatedAt: DateTimeField,
  }
})
export class RugbyGameStatistic extends BaseModel implements GameStatisticBase {
  gameUserId: number;
  points: number;
  tries: number;
  penaltyTries: number;
  conversionGoals: number;
  conversionMisses: number;
  penaltyMisses: number;
  penaltyGoals: number;
  dropGoals: number;
  dropGoalMisses: number;
  freeKicks: number;
  yellowCards: number;
  redCards: number;
  offloads: number;
  tackles: number;
  handlingErrors: number;
  carriesOverGainline: number;
  footFieldShots: number;
  footOutShots: number;
  footKicks5022: number;
  fouls: number;
  teamFouls: number;
  outs: number;
  runs: number;
  gameTime: number;
  plusMinus: number;
  updatedAt: Date;

  get id(): number {
    return this.gameUserId;
  }

  get gameMinutes(): number {
    return Math.floor(this.gameTime / 60);
  }

  get conversionKicks(): number {
    return (this.conversionGoals || 0) + (this.conversionMisses || 0);
  }

  get conversionGoalsPercent(): number {
    if (!this.conversionKicks) {
      return 0;
    }
    return Math.floor(1000 * this.conversionGoals / this.conversionKicks) / 10;
  }

  get penaltyKicksOnGoal(): number {
    return (this.penaltyGoals || 0) + (this.penaltyMisses || 0);
  }

  get penaltyGoalsPercent(): number {
    if (!this.penaltyKicksOnGoal) {
      return 0;
    }
    return Math.floor(1000 * this.penaltyGoals / this.penaltyKicksOnGoal) / 10;
  }

  get dropGoalKicks(): number {
    return (this.dropGoals || 0) + (this.dropGoalMisses || 0);
  }

  get dropGoalsPercent(): number {
    if (!this.dropGoalKicks) {
      return 0;
    }
    return Math.floor(1000 * this.dropGoals / this.dropGoalKicks) / 10;
  }

  get totalGoals(): number {
    return (this.conversionGoals || 0) + (this.dropGoals || 0) + (this.penaltyGoals || 0);
  }

  get footShots(): number {
    return (this.footFieldShots || 0) + (this.footOutShots || 0) + (this.footKicks5022 || 0);
  }

  get totalFouls(): number {
    return (this.fouls || 0) + (this.teamFouls || 0);
  }

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
